import HttpV2 from './HttpV2';

class EmailRecipientServiceV2 {
  static async getEmailRecipientTypes() {
    return HttpV2.get('admin/email-recipients/types');
  }

  static async addEmailRecipient(payload) {
    return HttpV2.post('admin/email-recipients', payload);
  }

  static async getEmailRecipients() {
    return HttpV2.get('admin/email-recipients');
  }

  static async deleteEmailRecipient(id) {
    return HttpV2.delete(`admin/email-recipients/${id}`);
  }
}

export default EmailRecipientServiceV2;
